<template>
  <div :class="['chart-wrapper', { fullscreen: isFullscreenModal }]">
    <div class="chart-wrapper-bg"></div>
    <div class="chart-content">
      <div class="big_btn icon-group" :class="{ rotate: isFullscreenModal }" @click="toggleFullScreen">
        <svg width="18px" height="18px" viewBox="0 0 18 18">
          <mask id="mask-2" fill="white">
            <path d="M16.4165008,1.58349915 C15.8054568,0.972321888 15.0693538,0.666666667 14.2085914,0.666666667 L3.79167499,0.666666667 C2.9309126,0.666666667 2.19480959,0.972321888 1.58349915,1.58349915 C0.972321888,2.19480959 0.666666667,2.9309126 0.666666667,3.79167499 L0.666666667,14.2084582 C0.666666667,15.0692206 0.972321888,15.8053236 1.58349915,16.416634 C2.19480959,17.0279445 2.9309126,17.3335997 3.79167499,17.3335997 L14.2084582,17.3335997 C15.0692206,17.3335997 15.8053236,17.0279445 16.4163677,16.416634 C17.0276781,15.8053236 17.3333333,15.0692206 17.3333333,14.2084582 L17.3333333,3.79167499 C17.3333333,2.9309126 17.0276781,2.19467641 16.4165008,1.58349915 L16.4165008,1.58349915 Z M14.1325438,9.98748608 C14.0385166,10.0235788 13.9478188,10.0416917 13.8612498,10.0416917 C13.6660034,10.0416917 13.5032537,9.972836 13.3730006,9.83552417 L11.8104964,8.27302003 L6.01636554,14.0674173 C5.87878739,14.2048623 5.71617083,14.2735848 5.5279831,14.2735848 C5.33979538,14.2735848 5.17704563,14.2048623 5.03960067,14.0674173 L3.93284908,12.9605325 C3.79540412,12.8232208 3.72668163,12.6602046 3.72668163,12.4722833 C3.72668163,12.2842288 3.79540412,12.121479 3.93284908,11.984034 L9.72724633,6.18963676 L8.16474217,4.62713259 C7.94046183,4.41736921 7.88985225,4.16432131 8.01278025,3.86758936 C8.13570826,3.58550755 8.34920077,3.44433346 8.65299143,3.44433346 L13.8612498,3.44433346 C14.0493044,3.44433346 14.2120542,3.51318913 14.3496323,3.65063408 C14.4869441,3.78794587 14.5556665,3.9508288 14.5556665,4.13888334 L14.5556665,9.34727492 C14.5556665,9.65106558 14.4144924,9.86442492 14.1325438,9.98748608 Z" id="path-1"></path>
          </mask>
          <use id="Mask" transform="translate(9.000000, 9.000133) scale(-1, 1) translate(-9.000000, -9.000133) " xlink:href="#path-1"></use>
        </svg>
      </div>
      <div v-if="series && series.length>0" class='highChart'></div>
    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import stockInit from 'highcharts/modules/stock'

exportingInit(Highcharts)
stockInit(Highcharts)

export default {
  name: 'baseChart',
  // props: ['series', 'extraOptions'],
  props: {
    series: {
      type: Array
    },
    extraOptions: {
      type: Object
    },
    showBaseLine: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      highchart: null,
      isFullscreenModal: false
    }
  },
  watch: {
    options () {
      this.initChart()
    }
  },
  computed: {
    height () {
      return this.isFullscreenModal ? window.innerHeight - 140 : 255
    },
    width () {
      return this.isFullscreenModal ? window.innerWidth - 110 : 384
    },
    fontSize () {
      return this.isFullscreenModal ? '16px' : '12px'
    },
    fontSizeXAxis () {
      return this.isFullscreenModal ? '16px' : '9px'
    },
    circleRadius () {
      return this.isFullscreenModal ? 10 : 4
    },
    options () {
      return { ...this.optionsBasic, ...this.extraOptions }
    },
    optionsBasic () {
      return {
        template: {
          chart: {
            type: 'line'
          }
        },
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        series: this.series,
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false,
              style: {
                color: '#4a4a4a',
                fontSize: this.fontSize,
                fontWeight: ' ',
                textOutline: '1px 1px contrast'
              }
            },
            marker: {
              radius: this.circleRadius
            }
          },
          column: {
            grouping: false,
            marker: {
              radius: 4,
              enabled: false
            }
          },
          line: {
            marker: {
              radius: 4
            }
          }
        },
        chart: {
          polar: false,
          inverted: false,
          style: {
            fontFamily: 'Arial',
            color: '#333',
            fontSize: '14px',
            fontWeight: 'normal',
            fontStyle: 'normal'
          },
          height: this.height,
          width: this.width,
          backgroundColor: 'transparent'
        },
        credits: {
          enabled: false
        },
        colors: [
          '#FDDBB7', // HPC含量
          '#3E95FF', // TOP 3 HPC含量
          'rgba(255, 173, 187, 1)', // HPC Index
          'rgba(255, 173, 187, 0.63)' // Top 2 HPC Index
        ],
        legend: {
          align: 'center',
          verticalAlign: 'top',
          floating: false,
          layout: 'horizontal',
          backgroundColor: 'transparent',
          itemMarginTop: 10,
          enabled: true,
          itemStyle: {
            fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif',
            color: '#333333',
            fontSize: this.fontSize,
            fontWeight: 'normal',
            fontStyle: 'normal',
            textOverflow: 'ellipsis',
            cursor: 'pointer'
          },
          y: -15,
          x: 0
        },
        yAxis:
          [
            { // Primary yAxis
              gridLineWidth: 1,
              labels: {
                format: '{value}%',
                style: {
                  fontSize: this.fontSize
                }
              },
              title: {
                text: ''
              }
            },
            { // Secondary yAxis
              tickInterval: 100,
              // minTickInterval: 50,
              gridLineWidth: 2,
              alignTicks: false,
              title: {
                text: ''
              },
              labels: {
                style: {
                  fontSize: this.fontSize
                },
                formatter: this.showBaseLine ? function () {
                  if (this.value === 100) {
                    return '基準值(' + this.value + ')'
                  } else {
                    return this.value
                  }
                } : null
              },
              softMax: 200,
              min: 0,
              opposite: true
            }
          ],
        xAxis: [
          {
            type: 'category',
            labels: {
              format: '{value}',
              step: 1,
              rotation: -60,
              style: {
                fontSize: this.fontSizeXAxis
              }
            }
          }
        ],
        tooltip: {
          enabled: true,
          shared: true,
          borderWidth: 1
        },
        lang: {
          thousandsSep: ',',
          downloadPNG: '下載成PNG',
          downloadJPEG: '下載成JPEG',
          downloadPDF: '下載成PDF',
          downloadSVG: '下載成SVG'
        },
        exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              align: 'right',
              y: -5,
              x: 10,
              menuItems: ['downloadPNG', 'downloadJPEG', 'downloadSVG']
            }
          }
        }
      }
    }
  },
  mounted () {
    this.initChart()
  },
  methods: {
    toggleFullScreen () {
      this.isFullscreenModal = !this.isFullscreenModal
    },
    initChart () {
      this.highChart = new Highcharts.Chart(this.$el.getElementsByClassName('highChart')[0], this.options)
    }
  }
}
</script>

<style lang='scss' scoped>
.chart-content {
  position: relative;
  .big_btn {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
    &.rotate {
      svg {
        transform: rotate(180deg) scale(1.2);
      }
    }
  }
}
.fullscreen {
  position: fixed;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  .chart-wrapper-bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(#4a4a4a, 0.6);
  }
  .chart-content {
    position: absolute;
    top: 30px;
    left: 30px;
    background: #fff;
    width: calc(100vw - 60px);
    height: calc(100vh - 120px);
    padding-left: 30px;
  }
}
</style>
